<template>
  <div class="tb-split-btn-wrapper" ref="wrapper">
    <button
      class="tb-btn tb-btn-contained medium-em mr-[2px]"
      @click="onClick"
      :class="{'disabled': disabled }"
      :disabled="disabled"
    >
      <slot />
    </button>
    <button
      class="tb-btn tb-btn-contained medium-em !ml-0 h-8 text-[1.1em] leading-none"
      @click="toggleDropdown"
      :class="{'disabled': disabled }"
      :disabled="disabled"
      type="button"
      aria-haspopup="menu"
      :aria-expanded="showOptions"
    >
      {{ splitButtonLabel }}
      <span class="fas fa-chevron-right" />
    </button>
    <div
      v-if="showOptions"
      class="tb-split-btn__dropdown fixed z-[2] max-h-[300px] max-w-[300px] min-w-[120px] overflow-auto rounded-[2px] bg-[#272727] px-0 py-2 text-[13px] shadow-[0_4px_8px_rgba(0,0,0,0.25)]"
      :style="dropdownStyles"
      role="menu"
    >
      <button
        v-for="option in options"
        :key="option.key"
        :class="option.divider ? 'tb-split-btn__dropdown-divider block h-px w-auto bg-white/12 my-2' : 'tb-split-btn__dropdown-option hover:cursor-pointer'"
        :type="option.divider ? 'button' : 'button'"
        :disabled="option.divider"
        role="menuitem"
        :tabindex="option.divider ? -1 : 0"
        @click="!option.divider && option.onClick()"
      >
        <span
          v-if="!option.divider"
          class="block overflow-hidden px-[6px] py-1 whitespace-nowrap text-ellipsis"
        >
          {{ option.label }}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SplitButton',

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },

    options: {
      type: Array,
      default: () => [],
    },

    splitButtonLabel: {
      type: String,
      default: '',
    },
  },

  mounted() {
    this.dimensions.width = this.$refs.wrapper.offsetWidth;
    this.dimensions.height = this.$refs.wrapper.offsetHeight;
  },

  beforeUnmount() {
    document.body.removeEventListener('mouseup', this.handleMouseUp);
  },

  data() {
    return {
      showOptions: false,
      dimensions: {
        width: 0,
        height: 0,
      },
    };
  },

  computed: {
    dropdownStyles() {
      const { height, width } = this.dimensions;

      // Magic
      return {
        transform: `translateY(calc(50% - ${height / 2}px))`,
        marginLeft: `${width}px`,
      };
    },
  },

  methods: {
    handleMouseUp() {
      // Just hide the options on any click
      setTimeout(() => {
        if (this.showOptions) {
          this.toggleDropdown();
        }
      });
    },

    onClick() {
      this.$emit('click');
    },

    toggleDropdown() {
      this.showOptions = !this.showOptions;

      if (this.showOptions) {
        document.body.addEventListener('mouseup', this.handleMouseUp);
      } else {
        document.body.removeEventListener('mouseup', this.handleMouseUp);
      }
    },
  },
};
</script>
